import React, { useState } from 'react';
import { Heading, Stack, Text, TextLink } from '@origin-digital/ods-core';
import { useHistory } from 'react-router-dom';
import { findSmeAccountByCriteria } from 'ts/services/find-account/FindAccountService';
import { USERNAME } from '../../../../constants/UrlParams';
import { ROUTES } from '../../../../Routes';
import { Page } from 'ts/components/Page';
import { AuthCard } from 'ts/components/Card';
import { BusinessCustomerLookupForm } from 'ts/passwordless-login/components/wizards/manual-reg-wizard/BusinessCustomerLookupForm';
import { LiveChat } from 'ts/components/LiveChat';

export const ForgotUsernameBusinessLookupPage = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [alertBoxError, setAlertBoxError] = useState<string | undefined>(undefined);

  const handleSubmit = async (accountNumber: string, businessName: string, abn: string) => {
    setLoading(true);
    try {
      const response = await findSmeAccountByCriteria(businessName, abn, accountNumber);
      history.push({
        pathname: ROUTES.FORGOT_USERNAME_ACCOUNT_FOUND,
        search: `?${USERNAME}=${response.data.email}`,
      });
    } catch (error) {
      setAlertBoxError(
        "We're having trouble finding you in our system. Don’t worry, [send us a message](LIVECHAT) and one of our agents will help you out.",
      );
      setLoading(false);
    }
  };

  return (
    <Page>
      <AuthCard>
        <Stack>
          <Heading variant="h3">Let's find your email</Heading>
          <Text weight="regular">
            Let's get some extra details to verify who you are. If you're a residential customer,
            find your{' '}
            <TextLink href={`#${ROUTES.FORGOT_USERNAME_FIND_CUSTOMER}`}>email here</TextLink>.
          </Text>
          <BusinessCustomerLookupForm
            handleSubmit={handleSubmit}
            loading={loading}
            alertBoxError={alertBoxError}
            setAlertBoxError={setAlertBoxError}
          />
        </Stack>
      </AuthCard>
      <LiveChat />
    </Page>
  );
};
